// jQuery CART overlay

$(document).ready(function(){
    $('.add-to-cart-button, .cart-open').on('click',function(e){
        e.preventDefault();
        var currentScroll = window.pageYOffset;
        setTimeout(function(){
            $('.cart, .cart-overlay').addClass('visible');
            $('main').addClass('faded');
            $('body').addClass('blocked');
            window.scrollTo(0,currentScroll);
          
                  if (typeof roarJs != 'undefined' && typeof roarJs.Legal != 'undefined') {
  roarJs.Legal.refresh();
  roarJs.Legal.bindCheckoutEvents();
}
                   
        },100);
    });
    
    $(document).on('click','.cart-overlay, .close-cart',function(e){
        e.preventDefault();
        $('.cart, .cart-overlay').removeClass('visible');
        $('main').removeClass('faded');
        $('body').removeClass('blocked');
    });
})

// VUE CART

var cart = new Vue({
    el: '.cart',
    data() {
        return {
            cart:null,
            items:0,
            upsell:true,
            relatedProducts: [] // aggregated related products from line items
        }
    },
    created()  {
        this.getCart();
    },
    methods: {
        getCart() {
            var loaded = false; 
            if (loaded == false) {
                axios('/cart.js').then(function(response){
                    cart.cart = response.data;
                    cart.items = cart.cart.item_count;
                    if (cart.items <= 3) {
                        cart.upsell = true;
                    } else {
                        cart.upsell = false;
                    }
                    
                    response.data.items.forEach(element => {
                        if (element.handle == 'collection') {
                            console.log('collection in cart')
                            cart.upsell = false;
                        }
                    });
                    
                    var x = document.querySelectorAll('.cart-count');
                    var i;
                    for (i = 0; i < x.length; i++) {
                        x[i].innerHTML = cart.items;
                    }

                    // Parse related products stored as line item properties
                    try {
                        cart.cart.items = (cart.cart.items || []).map(function(it){
                            var rel = [];
                            var raw = it.properties && (it.properties._related_products || it.properties.related_products);
                            if (raw) {
                                try { rel = JSON.parse(raw); } catch (e) { rel = []; }
                            }
                            it.related_products = Array.isArray(rel) ? rel : [];
                            return it;
                        });
                        // Aggregate unique related products across cart
                        var seen = new Set();
                        var agg = [];
                        cart.cart.items.forEach(function(it){
                            (it.related_products || []).forEach(function(p){
                                var key = p.id || p.handle || p.url;
                                if (key && !seen.has(key)) {
                                    seen.add(key);
                                    agg.push(p);
                                }
                            });
                        });
                        cart.relatedProducts = agg;
                    } catch (e) {
                        console.warn('Failed to parse related products from properties', e);
                        cart.relatedProducts = [];
                    }

                  if (typeof roarJs != 'undefined' && typeof roarJs.Legal != 'undefined') {
  roarJs.Legal.refresh();
  roarJs.Legal.bindCheckoutEvents();
}
                    
                }).catch(function(error){
                    console.log(error);
                })
                loaded = true;
            }
          
                  if (typeof roarJs != 'undefined' && typeof roarJs.Legal != 'undefined') {
  roarJs.Legal.refresh();
  roarJs.Legal.bindCheckoutEvents();
}
                   
        },
        addToCart(e) {
            e.preventDefault();
            var productId = store.state.product;
            if (e.target.dataset.id) {
                productId = parseFloat(e.target.dataset.id);
            }
            // Gather related products JSON from the clicked button (if present)
            var btn = e.currentTarget || e.target;
            var props = {};
            if (btn && btn.dataset && btn.dataset.relatedProducts) {
                props._related_products = btn.dataset.relatedProducts;
            }

            axios.post('/cart/add.js',{
                items: [
                    {
                        quantity:1,
                        id: productId,
                        // add properties only if we have any
                        ...(Object.keys(props).length ? { properties: props } : {})
                    }
                ]
            }).then(function(response){
                cart.getCart();
            })
        },
        removeFromCart(e) {
            var element = e.target.dataset.id;
            axios.post('/cart/change.js',{
                quantity:0,
                id: element     
            }).then(function(){
                cart.getCart();
            })
        },
        updateQuantity(e) {
            var inputQuantity = e.target.value;
            var element = e.target.dataset.id;
            axios.post('/cart/change.js',{
                quantity: inputQuantity,
                id: element     
            }).then(function(){
                cart.getCart();
            }).catch(function(error){
                $('.cart-error').html('Sorry, No more in stock').addClass('visible');
                setTimeout(function(){
                    $('.cart-error').removeClass('visible');
                },3500);
            })
        },
        increaseQuantity(e) {
            var element = e.target.dataset.id;
            axios('/cart.js').then(function(response){
                response.data.items.forEach(function(k,v){
                    if (k.id == element) {
                        var elQuantity = k.quantity;
                        axios.post('/cart/change.js',{
                            quantity:elQuantity + 1,
                            id: element     
                        }).then(function(response){
                            cart.getCart();
                        }).catch(function(error){
                            $('.cart-error').html('Sorry, No more in stock').addClass('visible');
                            setTimeout(function(){
                                $('.cart-error').removeClass('visible');
                            },3500);
                        })
                    }
                })
            })
        },
        decreaseQuantity(e) {
            var element = e.target.dataset.id;
            axios('/cart.js').then(function(response){
                response.data.items.forEach(function(k,v){
                    if (k.id == element) {
                        var elQuantity = k.quantity;
                        axios.post('/cart/change.js',{
                            quantity: elQuantity - 1,
                            id: element     
                        }).then(function(){
                            cart.getCart();
                        }).catch(function(error){
                            $('.cart-error').html('Sorry, No more in stock').addClass('visible');
                            setTimeout(function(){
                                $('.cart-error').removeClass('visible');
                            },3500);
                        })
                    }
                })
            })
        },
        toggleConsent(e) {
            var element = e.target;
            if (element.checked == true) {
                $('.cart-checkout').removeClass('cta-disabled');
            } else {
                $('.cart-checkout').addClass('cta-disabled');
            }
        }
    }
})

$('.product-form').each(function(){
    var element = this
    var formElement = $(this);
    var store = new Vue({
        data() {
            return {
                state: {
                    product: element.querySelector('.id').value
                }
            }
        }
    })
    
    var form = new Vue({
        el:this,
        data() {
            return {
                form: {
                    id: store.state.product
                },
            }
        },
        created()  {
            cart.getCart();
            
            axios('/cart.js').then(function(response) {
                var cart = response.data;
                var currency = cart.currency;
                if (currency == 'GBP') {
                    document.querySelectorAll('.currency').forEach(function(el) {
                        el.innerHTML = '£';
                    });
                } else if (currency == 'USD') {
                    document.querySelectorAll('.currency').forEach(function(el) {
                        el.innerHTML = '$';
                    });
                }
            });
            
        },
        mounted() {
            if ($('.variant-selector').length) {
                $('.variant-selector').on('change', function(){
                    var element = $(this).val();
                    Vue.set(store.state,'product', element);
                });
            } else {
                var element = $('.id').val();
                Vue.set(store.state,'product', element);
            }
        },
        methods: {
            onChange() {
                Vue.set(store.state,'product', $('.product-form').eq(index).find('select').val());
            },
            addToCart(e) {
                e.preventDefault();
                var productId = $('.id').val();    
                console.log(productId);
                var plan = null;
                
                if ($('.id').find('option:selected').data('selling-plan')) {
                    var plan = $('.id').find('option:selected').data('selling-plan');
                }
                
                if (e.target.dataset.id) {
                    productId = parseFloat(e.target.dataset.id);
                }
                
                var qty = 1;
                if ($('.quantity').length) {
                    qty = $('.quantity').val();
                }

                // Collect related products JSON from the clicked button (if any)
                var btn = e.currentTarget || e.target;
                var extraProps = {};
                if (btn && btn.dataset && btn.dataset.relatedProducts) {
                    extraProps._related_products = btn.dataset.relatedProducts;
                }
                
                if ($('.notes').length > 0 && $('.notes').val() != '') { 
                    console.log('notes found');
                    // Merge Engraving with extraProps
                    var properties = Object.assign({}, extraProps, {
                        'Engraving': $('.notes').val()
                    });
                    axios.post('/cart/add.js',{
                        items: [
                            {
                                quantity:qty,
                                id: productId,
                                selling_plan: plan,
                                properties: properties
                            }
                        ]
                    }).then(function(response){
                        cart.getCart();
                    }).catch(function(error){
                        $('.cart-error').html('Sorry, No more in stock').addClass('visible');
                        setTimeout(function(){
                            $('.cart-error').removeClass('visible');
                        },2000);
                    })
                    
                } else {
                    
                    axios.post('/cart/add.js',{
                        items: [
                            {
                                quantity:qty,
                                id: productId,
                                selling_plan: plan,
                                ...(Object.keys(extraProps).length ? { properties: extraProps } : {})
                            }
                        ]
                    }).then(function(response){
                        cart.getCart();
                    }).catch(function(error){
                        $('.cart-error').html('Sorry, No more in stock').addClass('visible');
                        setTimeout(function(){
                            $('.cart-error').removeClass('visible');
                        },2000);
                    })
                }
                
            }
        }
    })
})

Vue.filter('money', function(value, currencyFormat) {
    let formattedValue = (value / 100).toFixed(2); // Convert cents to the actual currency value

        console.log(currencyFormat, 'currencyFormat');

    if (currencyFormat.includes('{{amount_with_comma_separator}}')) {
        formattedValue = formattedValue.replace('.', ','); // Replace dot with comma
        return currencyFormat.replace('{{amount_with_comma_separator}}', formattedValue);
    } else if (currencyFormat.includes('{{amount}}')) {
        return currencyFormat.replace('{{amount}}', formattedValue);
    }
   
});